import React from 'react';
import { Section, SectionTitle } from '@repo/components/containers';
import Colors from './Form/Colors';

export default function ColorSelect({ onSelect, color }) {
  return (
    <Section>
      <SectionTitle underline>Color</SectionTitle>
      <Colors active={color} onSelect={onSelect} />
    </Section>
  );
}
